import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

import { AuthProvider } from './AuthProvider';
import { AnalyticsProvider } from './AnalyticsProvider';
import { AudienceProvider } from './AudienceProvider';
import { LocaleProvider } from './LocaleProvider';
import { ThemeProvider } from './ThemeProvider';
import { WhiteLabelProvider } from './WhiteLabelProvider';
import { createOptimizedQueryClient, preloadCriticalComponents } from '@/lib/performance';

// Preload critical components on app start
preloadCriticalComponents();

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(createOptimizedQueryClient);

  return (
    <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LocaleProvider>
          <AuthProvider>
            <AnalyticsProvider
              measurementId={import.meta.env.VITE_GA_MEASUREMENT_ID}
              gtmId={import.meta.env.VITE_GTM_ID}
            >
              <WhiteLabelProvider>
                <AudienceProvider>{children}</AudienceProvider>
              </WhiteLabelProvider>
            </AnalyticsProvider>
          </AuthProvider>
        </LocaleProvider>
      </ThemeProvider>
    </QueryClientProvider>
    </HelmetProvider>
  );
}
